import clickOutside from '@shared/directives/click-outside';

export default [clickOutside];
